export const getLibraryPathWithCountry = (path?: string) => {
  // TODO: Use cloudfront cookie to get country code
  return (
    '/library/au' +
    (path?.trim().length > 0 ? (path[0] === '/' ? path : `/${path}`) : '')
  );
};
